/**
 * QUANTAS licencas de empresa estao em uso.
 *
 * O sidenav lia `accounting.analytics.companiesCount`, um campo gravado que nao acompanha ativacao
 * e inativacao de empresa. Medido em 2026-09-22 sobre a base: numa amostra de 150 contabilidades
 * que TEM o campo preenchido, ele diverge do numero real de empresas ativas em 132; e em 917 delas
 * o campo esta `null` ou ausente — dessas, dois tercos tem empresa ativa e a tela mostrava
 * `0 (Ativas)` ao lado do limite do plano, com o botao de pedir mais licencas logo abaixo.
 *
 * A contagem passa a ser feita na hora, pela propria lista de empresas ativas.
 */
import _ from "lodash";

/**
 * O numero a exibir.
 *
 * `counted` e a contagem real; `null` enquanto ela nao chegou ou se a chamada falhou. Nesse caso
 * cai no valor gravado — e o que a tela ja mostrava, e um numero velho informa mais que um traco.
 *
 * ZERO contado e um numero, nao ausencia: contabilidade sem empresa ativa mostra `0`, e nao o
 * campo gravado, que e justamente quem costuma estar errado.
 */
export function licensesUsed({ counted = null, stored = null } = {}) {
    if (_.isNumber(counted)) return counted;
    return _.isNumber(stored) ? stored : 0;
}

/**
 * O recorte pedido a API.
 *
 * `status: ATIVO` porque licenca em uso e empresa ativa, e sem `user` de proposito — a licenca e
 * da contabilidade inteira, nao do que este usuario enxerga. Os grupos ficam de fora pelo padrao
 * do endpoint (`type !== 'all'` exclui `group`), que e o mesmo recorte do limite do plano.
 */
export function activeCompaniesQuery(accountingId) {
    return { accountingId, status: "ATIVO", summary: true };
}
